import { render, staticRenderFns } from "./VatRateShippingMethods.vue?vue&type=template&id=80c62a4c&"
import script from "./VatRateShippingMethods.vue?vue&type=script&lang=ts&"
export * from "./VatRateShippingMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports